<!-- @format -->

<template>
  <div v-if="isAppBasicDataReady">
    <ScrollView v-if="isDetailPage() && detailModel != null && getPageTypeByJSONDesc()">
      <HeaderPanel
        :breadcrumb-nav="[
          {
            label: _self.UI.title,
            location: {
              name: 'CARD_CREATE'
            }
          },
          {
            label: '详情'
          }
        ]"
        title=" "
      >
        <div slot="right">
          <a-button @click="_self.$router.push(_self.$route.path)">返回</a-button>
        </div>
        <PanelBox title=" ">
          <superFieldInfoList :vm="_self" />
        </PanelBox>
      </HeaderPanel>
    </ScrollView>

    <HeaderPanel v-show="!isDetailPage()" class="user-list-root" :title="UI.title" subTitle>
      <TableFilter
        slot="extra"
        @search="
          current = 1;
          generateFilterParamFromJSONDesc();
          fetchTableData(arguments);
        "
        :clearable="UI.TableFilter.clearable"
        @clear="onTableFilterClear"
      >
        <component
          :ref="item.comp"
          :key="index"
          :compDefine="item"
          :filterParam="filterParam"
          :style="item.style || {}"
          v-bind:is="item.comp.split('.')[0]"
          v-bind="item.attrs || {}"
          v-for="(item, index) in UI.TableFilter.items"
        >
          <dynamicComp where="UI.TableFilter.items" ref="dynamicComp" :compDefine="item" :vm="_self" />
        </component>
      </TableFilter>

      <Panel class="content">
        <FlexColumn :columns="flexColumns" class="content-box">
          <section slot="col-table">
            <dialogDefine ref="dialogDefine" :vm="_self" />
            <detailDialog
              :UI="UI"
              :title="UI[_self.dialogConfigKey].title"
              :width="UI[_self.dialogConfigKey].width"
              :cancelText="UI[_self.dialogConfigKey].cancelText || '取消'"
              :column="UI[_self.dialogConfigKey].column"
              :superPowerMode="UI[_self.dialogConfigKey].fieldInfoListConfig ? true : false"
              @cancel="onDetailDialogCancel"
              @confirm="onDetailDialogConfirm"
              v-if="detailModel != null"
              :detailModel="detailModel"
              ref="detailDialog"
            />
            <b-table
              :columns="tableColums"
              ref="paginationTable"
              :dataSource="tableData"
              :rowKey="UI.tableConfig.rowKey"
              :scroll="{ x: tableWidth, y: 400 }"
              :loading="tableLoading"
              :pagination="_self.tableData.length == 0 ? false : computedPagination"
              @change="handleTablePaginationChange"
              :hasSumLine="true"
              :sumRowData="totalRow"
              :sortConfig="{ multiple: true, remote: true, trigger: 'cell', orders: [null, 'desc', 'asc'] }"
              @sort-change="onSortChange"
            >
              <template v-slot:toolbar_tools>
                <exports
                  @fetchTableData="
                    current = 1;
                    generateFilterParamFromJSONDesc();
                    fetchTableData(arguments);
                  "
                  style="margin-right: 8px"
                ></exports>
                <TableHeader class="pl0 pr0 pt0" style="padding: 0; margin-right: 8px">
                  <template slot="header-right">
                    <exportArea :vm="_self" />

                    <component
                      :resource="UI.tableConfig.tableHeader.export.resourceKey"
                      v-bind:is="UI.tableConfig.tableHeader.export.resourceKey ? 'Authorized' : 'span'"
                    >
                      <a-button
                        v-if="UI.tableConfig.tableHeader.export && UI.tableConfig.tableHeader.export.httpUrl"
                        @click="createHttp('UI.tableConfig.tableHeader.export', getSearchMap())"
                        type="primary"
                        ghost
                        icon="export"
                        >导出</a-button
                      >
                    </component>
                    <!--  -->
                  </template>
                </TableHeader>
              </template>
              <template slot="table-cell-render" slot-scope="text, record">
                <span v-if="!record.isTotalRow">
                  <span :key="fieldKey" v-for="(v, fieldKey) in _self.customSlots.tableColumns">
                    <span v-if="text == record[fieldKey]">
                      <component
                        v-bind="updateAttrThroughTplEngine(v.attrs, record)"
                        :text="text"
                        v-bind:is="v.comp"
                        :color="getATagColor(text)"
                      >
                        {{ text }}
                      </component>
                    </span>
                  </span>
                </span>
              </template>

              <template slot="operation" slot-scope="text, record">
                <span v-if="!record.isTotalRow">
                  <span :key="item.label" v-for="item in _self.UI.tableConfig.operateColumn">
                    <component :resource="item.resourceKey" v-bind:is="item.resourceKey ? 'Authorized' : 'span'">
                      <a-button type="link" @click.stop="handleOperateBtnClick(item, record)" size="small">{{
                        item.label
                      }}</a-button>
                    </component>
                  </span>
                </span>
              </template>
            </b-table>
          </section>
        </FlexColumn>
      </Panel>
    </HeaderPanel>
  </div>
</template>
<script>
/** @format */

/** @format */

import core, { createSlotCompFun } from './javascript.tsx';
export default core;

export const createSlotComp = createSlotCompFun;
</script>
